import { render, staticRenderFns } from "./activityChart.vue?vue&type=template&id=0cf546c4&scoped=true"
import script from "./activityChart.vue?vue&type=script&lang=js"
export * from "./activityChart.vue?vue&type=script&lang=js"
import style0 from "./activityChart.vue?vue&type=style&index=0&id=0cf546c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf546c4",
  null
  
)

export default component.exports